import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getBuyPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/#koupit",
	});
}
